import { selectEarliestStartedStudyCards } from "#select-earliest-started-study-cards";

type MeaningStudyCardCandidate = {
  startedStudyingAt: string | null;
  userGraphemeMeaningCard?: { grapheme: string } | null;
};

/**
 * Selects the one study card that establishes each learned character.
 * Pronunciation cards do not make a character learned; only its glyph → meaning card does.
 */
export function selectLearnedMeaningStudyCardsByGrapheme<
  const TStudyCard extends MeaningStudyCardCandidate,
>(activeStudyCards: readonly TStudyCard[]): ReadonlyMap<string, TStudyCard> {
  return selectEarliestStartedStudyCards(
    activeStudyCards,
    (studyCard) => studyCard.userGraphemeMeaningCard?.grapheme,
  );
}
